export default __webpack_public_path__ + "static/media/man.1a598cb3.png";